import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Backdrop from './Backdrop.js';
import {useHotkeys} from '../../hotkeys.js';
import {FooterGimmickBar, GimmikContainer, ModalHeader, ModalTitle} from './ModalFeatures.js';
import {ModalContainer} from './ModalContainer.js';
import {ModalCloseBtn} from '../../shared-components/custom-features/app-element/Btn.js';
import {ColorTheme} from '../../shared-components/variables/feature-colors/ColorTheme.js';
import FocusTrap from '../../shared-components/FocusTrap.js';
import VariableTextSize from '../../shared-components/variables/VariableTextSize.js';
import {ModalGrid} from './ModalGrid.js';

export const Dialog = ({show, size, dialogRef, ...props}) => {
    if (!show) return null;
    return <Modal {...props} size={size} dialogRef={dialogRef} />;
};

function Modal({size, children, onHide, title, overflowNone, backdrop, dialogRef}) {
    useHotkeys(
        () => ({
            Escape: onHide,
        }),
        [onHide],
    );
    return ReactDOM.createPortal(
        <ModalDialog show={true}>
            <ModalContainer ref={dialogRef} overflowNone={overflowNone} size={size} popup={true}>
                <ModalGrid size={size}>
                    {title && (
                        <ModalHeader>
                            <ModalTitle>{title}</ModalTitle>
                            <ModalCloseBtn onClick={onHide} />
                        </ModalHeader>
                    )}
                    {children}
                </ModalGrid>
                <GimmikContainer>
                    <FooterGimmickBar />
                </GimmikContainer>
            </ModalContainer>
            {backdrop && <Backdrop show={true} onClick={onHide} />}
        </ModalDialog>,

        document.getElementById('portal'),
    );
}

export const ModalDialog = ({children, show, size, closing, footer}) => (
    <ColorTheme>
        <FocusTrap>
            <Wrapper show={show} footer={footer} size={size} closing={closing}>
                {children}
            </Wrapper>
        </FocusTrap>
    </ColorTheme>
);

const Wrapper = styled.div`
    ${VariableTextSize}
    --modal-border-radius: 20px;
    --modal-gimmick-bar-height: 8px;
    --modal-gimmick-container: calc(var(--modal-gimmick-bar-height) + 12px);
    --grid-padding: 28px;
    --modal-padding: 28px;

    position: fixed;
    padding: var(--space-xxl);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9000;
    overflow: hidden;
    outline: 0;
    display: flex;
    align-items: center;
`;
